// src/pages/GDPR.tsx
const GDPR = () => {
    return (
      <div className="min-h-screen p-6 bg-background">
        <div className="max-w-4xl mx-auto space-y-8">
          <h1 className="text-4xl font-bold tracking-tight">GDPR Compliance</h1>
          <div className="prose prose-invert max-w-none">
            <p>Last updated: {new Date().toLocaleDateString()}</p>
            
            <h2>General Data Protection Regulation (GDPR) Information</h2>
            <p>
              We are committed to protecting your personal data and complying with the General Data Protection Regulation (GDPR).
              This page outlines how we collect, use, and protect your data.
            </p>
  
            <h2>Your Rights Under GDPR</h2>
            <ul>
              <li>Right to access your data</li>
              <li>Right to rectification</li>
              <li>Right to erasure</li>
              <li>Right to restrict processing</li>
              <li>Right to data portability</li>
              <li>Right to object</li>
            </ul>
  
            <h2>Data We Collect</h2>
            <p>
              We collect minimal data necessary for the operation of our service:
            </p>
            <ul>
              <li>Color preferences</li>
              <li>Resolution settings</li>
              <li>Language preferences</li>
            </ul>
  
            <h2>Contact for GDPR Requests</h2>
            <p>
              For any GDPR-related requests or questions, please contact us at:
              <br />
              Email: privacy@wsonline.com
            </p>
          </div>
        </div>
      </div>
    );
  };
  
  export default GDPR;